import { useCollaboratorAccruals } from ".";

import { useCurrentCompany } from "hooks/useCurrentCompany";

export const useCollaboratorAccrualsTable = ({
  collaboratorId,
}: {
  collaboratorId?: string;
}) => {
  const companyInfo = useCurrentCompany();

  const { data, ...rest } = useCollaboratorAccruals({
    collaboratorId,
    colaboraInstanceId: companyInfo?.instanceId,
  });

  return { data, ...rest };
};
